"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseTheme = void 0;
exports.baseTheme = {
    'thema-id': '0',
    logo: 'url',
    common: {
        radius: '4px',
        radiusXXS: '4px',
        radiusXS: '4px',
        radiusS: '4px',
        radiusM: '4px',
        radiusL: '4px',
        radiusXL: '4px',
        'font-family': 'Roboto Flex',
        'icons-toggle': true,
        'icons-url-prefix': '-pick-',
        'box-shadow': 'box-shadow: 0px 8px 25px rgba(99, 119, 156, 0.2)',
        a: {
            color: '#1698D9',
            decoration: 'none',
        },
    },
    colors: {
        surface: {
            primary: '#FFFFFF',
            secondary: '#FAFAFB',
            background: '#F1F2F6',
            brand: '#1698D9',
            brand2: '#21145A',
            accent: '#1698D9',
            interactive: {
                'interactive-tined': '#C5EAFC',
                'interactive-light': '#DDF3FD',
            },
            success: {
                'success-tined': '#BEF4D0',
                'success-light': '#DBFFEC',
            },
            warning: {
                'success-tined': '#FFD8BD',
                'success-light': '#FFEADB',
            },
            error: {
                'success-tined': '#FFD1D7',
                'success-light': '#FEE7EA',
            },
            'matt-glass': {
                'success-tined': {
                    background: 'gba(255, 255, 255, 0.8)',
                    'background-filter-blur': '32px',
                },
                'success-light': {
                    background: 'rgba(241, 242, 246, 0.8)',
                    'background-filter-blur': '32px',
                },
            },
        },
        text: {
            primary: '#1F232B',
            inverse: '#FFFFFF',
            secondary: '#737B8C',
            tertiary: '#A2ADC1',
            interactive: '#1698D9',
            'interactive-clarified': '#86C7E7',
            success: '#1AA800',
            warning: '#FF8833',
            error: '#F3566A',
        },
        neutral: {
            '0': '#FFFFFF',
            '10': '#F1F2F6',
            '20': '#E4E7EE',
            '30': '#DCE1EF',
            '50': '#A2ADC1',
            '70': '#8591A9',
            '80': '#63779C',
            '100': '#1F232B',
        },
        accent: {
            interactive: {
                normal: '#1698D9',
                darkened: '#0088CC',
                clarified: '#6EC9F7',
                faded: '#9EDBFA',
            },
            action: {
                normal: '#1698D9',
                darkened: '#0088CC',
                clarified: '#6EC9F7',
                faded: '#9EDBFA',
            },
            success: {
                normal: '#1AA800',
                darkened: '#168801',
                clarified: '#BEF4D0',
                faded: '#DBFFEC',
            },
            warning: {
                normal: '#FF8833',
                darkened: '#E56000',
                clarified: '#FFA666',
                faded: '#FFEADB',
            },
            error: {
                normal: '#F3566A',
                darkened: '#CF1730',
                clarified: '#FFD1D7',
                faded: '#FEE7EA',
            },
        },
        'on-accent': {
            primary: '#FCFCFF',
            darkened: '#E4E4E5',
            secondary: 'rgba(252, 252, 255, 0.8)',
            tertiary: 'background: rgba(252, 252, 255, 0.4)',
            quaternary: 'rgba(252, 252, 255, 0.2)',
        },
        overlay: {
            primary: 'rgba(31, 35, 43, 0.25)',
            secondary: 'rgba(90, 97, 128, 0.1)',
            ripple: {
                interactive: 'rgba(22, 152, 217, 0.15)',
                success: 'rgba(51, 204, 102, 0.15)',
                warning: ' rgba(255, 136, 51, 0.15)',
                error: 'rgba(243, 86, 106, 0.15)',
            },
        },
        gradient: {
            home: 'linear-gradient(103.18deg, #F53D55 8.82%, #B14C98 37.31%, #5864E1 65.8%, #25A4F4 94.29%)',
            health: 'linear-gradient(180deg, #0E91E4 0.01%, #44FDAF 100%)',
            pet: 'linear-gradient(315deg, #EA66FF 0%, #FF5C69 50%, #FFAA00 100%)',
            sport: 'linear-gradient(135deg, #1AA1E5 0%, #0BDAC9 50%, #C4EA06 100%)',
            'anti-mite': 'linear-gradient(345.96deg, #F199FF 0%, #5C33FF 100%)',
        },
        icon: {
            primary: '#1F232B',
            inverse: '#FFFFFF',
            secondary: '#1698D9',
            tertiary: '#21145A',
            quaternary: '#8591A9',
            success: '#1AA800',
            warning: '#FF8833',
            error: '#F3566A',
        },
        product: {
            travel: '#D9EDFF',
            apartment: '#FFF3DC',
            house: '#FFEECF',
            mortgage: '#F5F5F5',
            sport: '#D4FCFF',
            pet: '#FFEFF8',
            antimite: '#E1FAC9',
            health: '#DEFFDF',
            partner: '#F6E2FF',
        },
        additional: {
            light: {
                yellow: '#FFF3DC',
                orange: '#FFE0CF',
                green: '#DEFFDF',
                blue: '#D4FCFF',
                lime: '#E1FAC9',
                'dark-blue': '#D9EDFF',
                pink: '#FFEFF8',
                neutral: '#F5F5F5',
                purple: '#F6E2FF',
            },
            darkened: {
                yellow: '#B87900',
                orange: '#B84000',
                green: '#00B806',
                blue: '#00ABB8',
                lime: '#5AA810',
                'dark-blue': '#0061B8',
                pink: '#B80067',
                neutral: '#5C5C5C',
                purple: '#7F00B8',
            },
            partners: {
                gosuslugi: '#0D4CD3',
            },
        },
    },
    components: {
        risks: {
            'text-toggle': true,
            'icons-toggle': true,
            'icons-url-prefix': '-pick-',
        },
    },
};
